import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const PlanViewModule = new Module({
  id: 'plan-view',
  name: 'Plan',
  path: 'plan',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Plan/View'))
  ),
  actions: {
    add: {
      id: 'add-plan',
      name: 'add-plan',
      label: 'Add Plan'
    }
  }
});

export const PlanAddModule = new Module({
  id: 'plan-add',
  name: 'planAdd',
  path: 'plan/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Plan/Form'))
  ),
  actions: {
    add: {
      id: 'add-plan-action',
      name: 'add-plan-action',
      label: 'Add Plan'
    }
  }
});

export const PlanEditModule = new Module({
  id: 'plan-edit',
  name: 'PlanEdit',
  path: 'plan/edit',
  pathDef: 'plan/edit/:id',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Plan/Form'))
  ),
  actions: {
    edit: {
      id: 'edit-plan',
      name: 'edit-plan',
      label: 'Edit'
    },
    delete: {
      id: 'delete-plan',
      name: 'delete-plan',
      label: 'Delete'
    }
  }
});

const PlanModules = [PlanViewModule, PlanAddModule, PlanEditModule];

export default new ModuleBundle('Plan', PlanModules);
